"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var BookStacked_exports = {};
__export(BookStacked_exports, {
  default: () => BookStacked_default
});
module.exports = __toCommonJS(BookStacked_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.9883 3.96094C15.9232 3.73958 15.7865 3.57682 15.5781 3.47266C15.3828 3.35547 15.1745 3.32292 14.9531 3.375L11.7305 4.23438C11.6523 4.26042 11.5807 4.29948 11.5156 4.35156C11.4505 4.39062 11.3919 4.4362 11.3398 4.48828V4.41016C11.3398 4.1888 11.2552 4 11.0859 3.84375C10.9297 3.67448 10.7344 3.58984 10.5 3.58984H3C2.76562 3.58984 2.5638 3.67448 2.39453 3.84375C2.23828 4 2.16016 4.1888 2.16016 4.41016V16.0898C2.16016 16.3112 2.23828 16.5065 2.39453 16.6758C2.5638 16.832 2.76562 16.9102 3 16.9102H10.5C10.7344 16.9102 10.9297 16.832 11.0859 16.6758C11.2552 16.5065 11.3398 16.3112 11.3398 16.0898V5.95312L14.1719 16.5391C14.224 16.7604 14.3477 16.9297 14.543 17.0469C14.7513 17.151 14.9661 17.1771 15.1875 17.125L18.4102 16.2656C18.6315 16.2005 18.8008 16.0703 18.918 15.875C19.0352 15.6667 19.0612 15.4518 18.9961 15.2305L15.9883 3.96094ZM17.1797 12.2812L14.2695 13.0625L12.1602 5.17188L15.0508 4.39062L17.1797 12.2812ZM17.3945 13.082L18 15.3281L15.0898 16.1094L14.4844 13.8633L17.3945 13.082ZM3.17578 4.58594H6.16406V12.75H3.17578V4.58594ZM3.17578 15.9141V13.5898H6.16406V15.9141H3.17578ZM7.33594 15.9141V13.5898H10.3242V15.9141H7.33594ZM10.3242 4.58594V12.75H7.33594V4.58594H10.3242Z",
      fill: "currentColor"
    }
  )
);
const SvgBookStacked = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var BookStacked_default = SvgBookStacked;
